import { writable } from "svelte/store";
let MenuStore;
export default MenuStore = writable([]);
